import { api } from './api';
import { DealInsights } from 'Models/deal-insights';
import { WonTouchpointStage } from 'Models/deal-insights-result';
import { DealInsightsResult } from 'Models/deal-insights-result';

export const dealInsightsApi = api.injectEndpoints({
  endpoints: (build) => ({

    getClosedWonInsights: build.mutation<
      { metrics: { closedWon?: { touchpointByStage: WonTouchpointStage[] } } },
      { companyId: string; params: Pick<DealInsights, 'dateRange' | 'pipelineId'> }
    >({
      query: ({ companyId, params }) => ({
        url: `integration/core/company/${companyId}/insights/closed-won`,
        method: 'POST',
        body: params,
      }),
      invalidatesTags: ['DealInsights'],
    }),
    getDealInsights: build.mutation<
      DealInsightsResult,
      { companyId: string; params: DealInsights }
    >({
      query({ companyId, params }) {
        return {
          url: `integration/core/company/${companyId}/insights/deals`,
          method: 'POST',
          body: params,
        };
      },
      invalidatesTags: ['DealInsights'],
    }),
  }),
});

export const {
  useGetClosedWonInsightsMutation,
  useGetDealInsightsMutation} = dealInsightsApi;